import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ReactComponent as AILogo } from "../../../Assets/Svg/AILogo.svg";
import AIArgumentSuggestion from "../../../Components/Functionality/AIArgumentSuggestion";
import ArgumentEditorTextArea from "../../../Components/UI/Inputs/ArgumentEditorTextArea";
import { useCreateDebateContext } from "../../../Context/CreateDebateContext";
import { usePlan } from "../../../Context/PlanContext";
import { handleAIUpgradePlan } from "../../../Services/SweetAlert";
import useDebounce from "../../../Services/useDebounce";
import { ARGUMENT_STRUCTURE } from "../../../Utils/Constant";
import { argumentIdeas, convertArrayToString } from "../../../Utils/Helper";
import { useArgumentAgent } from "../../../Web-Hooks/Agents/use-argument-agent";

const AddArgumentWithAi = ({ error, setError }) => {
  const [argumentHighlight, setArgumentHighlight] = useState("debatebase");
  const { debateInfo, handleStateUpdate } = useCreateDebateContext();
  const motion = useDebounce(debateInfo.MotionOrClaim, 1000);
  const [showAIValidator, setShowAIValidator] = useState(false);
  const [activeBlinkingButton, setActiveBlinkingButton] = useState();
  const { currentPlan } = usePlan();

  const { data: argumentAssistance, isLoading: isArgumentsLoading } =
    useArgumentAgent(
      motion,
      debateInfo?.Fields?.length > 0
        ? convertArrayToString(debateInfo.Fields)
        : "",
      debateInfo?.SideForDebate,
      currentPlan?.totalAIAgent?.argumentassistantagent
    );
  const navigate = useNavigate();

  useEffect(() => {
    if (
      argumentHighlight !== "debatebase" &&
      debateInfo?.SideForDebate !== argumentHighlight?.side
    ) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "The selected argument is not for the selected side of the debate. Do you want to continue?",
        showDenyButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "No",
        reverseButtons: true,
        customClass: {
          confirmButton: "bg-[#7647FC] text-white",
          denyButton: "bg-gray-300 text-gray-800",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return;
        } else if (result.isDenied) {
          setArgumentHighlight("debatebase");
        } else if (result.isDismissed) {
          return;
        }
      });
    }
  }, [debateInfo?.SideForDebate]);

  const handleArgument = () => {
    if (!currentPlan?.totalAIAgent?.argumentassistantagent) {
      handleAIUpgradePlan(ARGUMENT_STRUCTURE, () =>
        navigate(`/upgrade-plan?plan=debato-plan`)
      );
      return;
    }
    setShowAIValidator(true);
  };
  return (
    <div>
      <AIArgumentSuggestion
        open={showAIValidator}
        debateInfo={debateInfo}
        handleClose={() => setShowAIValidator(false)}
        handleStateUpdate={handleStateUpdate}
        pauseAIButtonBlinking={() => setActiveBlinkingButton("Argument")}
        setActiveBlinkingButton={setActiveBlinkingButton}
        argumentAssistance={argumentAssistance}
        setArgumentHighlight={setArgumentHighlight}
        isArgumentsLoading={isArgumentsLoading}
      />
      <div
        className="flex flex-col gap-2 items-center mt-2"
        onMouseEnter={() => setActiveBlinkingButton(true)}
        onMouseLeave={() => setActiveBlinkingButton(false)}
      >
        <div
          className={`flex flex-row justify-between w-full ${
            debateInfo?.CreatorOpeningArgument !== "" && " pr-8"
          }  `}
        >
          <label htmlFor={"argument"} className="text-lg font-semibold">
            Current Round Argument
          </label>
          {debateInfo?.MotionOrClaim &&
            debateInfo?.Fields?.length > 0 &&
            debateInfo?.SideForDebate && (
              <Button
                size="sm"
                variant="outlined"
                id="argumentStructurerButton"
                onClick={handleArgument}
                onMouseEnter={() => setActiveBlinkingButton(true)}
                onMouseLeave={() => setActiveBlinkingButton(false)}
                className={` flex items-center p-1 justify-end self-end gap-2 border-[#7647FC] -pl-8`}
              >
                <AILogo className="h-6 w-6" />
                {activeBlinkingButton && (
                  <span
                    className="text-[#7647FC] font-semibold animate__animated animate__fadeIn animate__faster"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Argument Structure Suggestion
                  </span>
                )}
              </Button>
            )}
        </div>
        <div className="w-full flex flex-row gap-2 ">
          <div className="flex flex-row w-full gap-2 ">
            <div className="flex flex-col w-full gap-2">
              {argumentHighlight !== "debatebase" && (
                <div className=" flex justify-start items-start border-2 border-debatePalette-link p-2 w-full rounded-md py-2">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: argumentIdeas(argumentHighlight?.arguments),
                    }}
                  />
                </div>
              )}
              <ArgumentEditorTextArea
                setArgumentHighlight={setArgumentHighlight}
                debateInfo={debateInfo}
                handleStateUpdate={handleStateUpdate}
                argumentHighlight={argumentHighlight?.arguments}
              />
            </div>

            {/* <div
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{ height: "150px" }}
                  className={`relative   area border-2 p-2 rounded-md w-full  ${shadowNormal} ${
                    isFocused
                      ? "border !border-debatePalette-shadow !shadow-[0_1px_4px_1.5px_rgba(0,_139,_250,_0.25)]"
                      : "border-debatePalette-buttonBorder"
                  }`}
                >
                  <HighlightWithinTextarea
                  style={{
                    minHeight: "150px",
                  }}
                    value={debateInfo?.CreatorOpeningArgument || ""}
                    onChange={(value) => {
                      let newHighLight = FindCommonSubstrings(argumentHighlight,value);
                      handleStateUpdate({
                        ...debateInfo,
                        CreatorOpeningArgument: value,
                      });
                      setArgumentHighlight(newHighLight);
                      setCharCount(value.length);
                    }}
                    placeholder=""
                    highlight={[
                      {
                        highlight: argumentHighlight,
                        className: "highlighted",
                      },
                    ]}
                  />
                  <span className="absolute bottom-0 right-3">
                    {" "}
                    {CountWords(debateInfo?.CreatorOpeningArgument)}
                  </span>{" "}
                </div> */}
            <div>
              {debateInfo?.CreatorOpeningArgument !== "" && (
                <CheckCircleIcon color="green" className="h-7 w-7 " />
              )}
            </div>
          </div>
        </div>
        {error?.CreatorOpeningArgument && (
          <p className="text-red-500 text-sm font-semibold">
            {error.CreatorOpeningArgument}
          </p>
        )}
      </div>
    </div>
  );
};

export default AddArgumentWithAi;
